<template>
  <v-content>
    <v-container>
      <v-layout text-xs-center wrap class="mt-3 text-center">
        <v-flex xs12>
          <p>
            Audit Date:
            {{ moment(this.getAuditEvent.auditDate).format("MMMM YYYY") }}
          </p>
          <p>Drug Name: {{ this.getAuditEvent.drugName }}</p>
          <p>
            Project Designation: {{ this.getAuditEvent.projectDesignation }}
          </p>
          <form ref="uploadForm" id="uploadForm">
            <v-autocomplete
              class="mb-3"
              v-model="form.company"
              :items="companies"
              item-text="name"
              item-value="id"
              label="Name"
              @change="setNotes"
            ></v-autocomplete>
            <v-flex class="mb-3" xs12>
              <!-- TODO test this <input
                type="file"
                accept="image/*"
                name="photo"
                capture="camera"
                @change="selectFile"
              />-->
              <input
                type="file"
                accept="image/*"
                name="photo"
                @change="selectFile"
              />
            </v-flex>
            <v-container fill-height>
              <v-layout row wrap align-center>
                <v-flex class="text-xs-center">
                  <div>
                    <v-checkbox
                      class="center-checkbox"
                      v-model="failedAudit"
                      :label="`Alternate Photo`"
                    ></v-checkbox>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
            <v-container>
              <v-row>
                <v-col>
                  <v-select
                    placeholder="Label (Optional)"
                    v-model="form.label"
                    :items="['Exam Room', 'Office', 'Waiting Room', 'Other']"
                  ></v-select>
                </v-col>
                <v-col>
                  <v-btn @click="showNotesDialog = true">Add Notes</v-btn>
                </v-col>
              </v-row>
            </v-container>
            <v-flex class="mb-3" xs12>
              <v-btn type="button" color="info" @click="getLocation"
                >Get location</v-btn
              >
              <i class="material-icons" v-if="form.geolocation !== null"
                >check_circle_outline</i
              >
            </v-flex>
            <v-btn
              v-if="
                form.geolocation !== null &&
                form.company !== null &&
                (form.photo !== null || failedAudit)
              "
              type="button"
              color="success"
              @click="submitPhoto"
              :disabled="submittingPhotoProgress"
              >Submit</v-btn
            >
            <v-btn v-else type="button" disabled>Waiting for Input</v-btn>

            <v-progress-linear
              v-if="submittingPhotoProgress"
              :indeterminate="submittingPhotoProgress"
            ></v-progress-linear>
          </form>

          <v-snackbar
            v-model="successSnackbar"
            color="success"
            :multi-line="true"
            :timeout="3000"
            :vertical="true"
          >
            Successfully submitted picture!
            <v-btn dark text @click="successSnackbar = false"></v-btn>
          </v-snackbar>
          <v-alert v-model="geoAlert" type="error"
            >Unable to get your Location</v-alert
          >
          <v-alert v-model="submitAlert" type="error"
            >Error submitting photo!</v-alert
          >
          <v-alert v-model="tookTooLongAlert" type="error"
            >Time to submit photo exceeded time limit!</v-alert
          >
          <p v-if="submitAlert">{{ submitAlertError }}</p>
        </v-flex>
      </v-layout>

      <v-dialog v-model="showNotesDialog" persistent max-width="450">
        <v-card>
          <v-card-title class="headline">Notes</v-card-title>
          <vue-editor
            class="pb-2"
            v-model="form.notes"
            :editorToolbar="customToolbar"
          ></vue-editor>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="showNotesDialog = false"
              >Save</v-btn
            >
            <v-btn
              color="error"
              text
              @click="
                form.notes = null;
                showNotesDialog = false;
              "
              >Clear</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </v-content>
</template>

<script>
import axios from "axios";
import _ from "lodash";
import { VueEditor } from "vue2-editor";
import { setTimeout } from "timers";
export default {
  name: "UploadPhoto",
  components: {
    VueEditor,
  },
  data() {
    return {
      loadingGeolocation: true,
      geoAlert: false,
      submitAlert: false,
      submitAlertError: "",
      successSnackbar: false,
      tookTooLongAlert: false,
      form: {
        company: null,
        photo: null,
        geolocation: null,
        date: null,
        label: null,
        notes: null,
      },
      failedAudit: false,
      submittingPhotoProgress: false,
      companies: [],
      compareDate: null,
      showNotesDialog: false,
      customToolbar: [["bold", "italic", "underline"]],
    };
  },
  computed: {
    getBaseUrl() {
      return this.$store.getters.getBaseUrl;
    },
    getAuditEvent() {
      return this.$store.getters.getAuditEvent;
    },
  },
  async mounted() {
    await this.validateUser();
    this.getSamplesByAuditorEvent();
  },
  methods: {
    submitPhoto() {
      if (this.failedAudit) {
        this.form.failed = "FAILED";
        this.compareDate = new Date();
      } else {
        this.form.failed = null;
        this.compareDate = new Date();
      }

      // Check dates before submitting
      const diffTime = Math.abs(
        this.form.date.getTime() - this.compareDate.getTime()
      );
      const diffSeconds = Math.ceil(diffTime / 1000);
      if (diffSeconds > 180) {
        return (this.tookTooLongAlert = true);
      }

      // todo Form Validation

      if (this.form.photo === null) {
        this.submitAlert = true;
        submitAlertError = "Please take a picture before submitting it!";
        return;
      }

      let formData = new FormData();
      formData.append("auditorID", this.getAuditEvent.auditorID);
      formData.append("photo", this.form.photo);
      formData.append("company", this.form.company);
      formData.append("geolocation", this.form.geolocation);
      formData.append("date", this.form.date);
      formData.append("failed", this.form.failed);
      formData.append("label", this.form.label);
      formData.append("notes", this.form.notes);

      // Animation for user
      this.submittingPhotoProgress = true;

      let config = {
        url: `${this.getBaseUrl}/upload`,
        method: "POST",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      axios(config)
        .then((response) => {
          if (response.status === 201) {
            this.successSnackbar = true;
            let failed = this.failedAudit;
            let auditSampleId = this.form.company;
            this.resetForm();
            // redirect to /sign/:id if failed is selected
            if (failed) {
              if (this.getAuditEvent.signatureRequired) {
                this.$router.push(
                  `/sign/${this.getAuditEvent.auditorID}?q=${auditSampleId}`
                );
              }
            }
          } else {
            // todo if 400, say no photo was attached as a warning
            this.submitAlertError = "Error submitting photo. Please try again!";
            this.submitAlert = true;
            this.submittingPhotoProgress = false;
          }
        })
        .catch((err) => {
          // eslint-disable-next-line
          this.submitAlertError = err;
          console.log(err);
          this.submitAlert = true;
          this.submittingPhotoProgress = false;
        });
    },
    selectFile(e) {
      this.compareDate = new Date();
      let photo = e.target.files[0];
      this.form.photo = photo;
    },
    resetForm() {
      this.form.company = null;
      this.form.photo = null;
      this.form.geolocation = null;
      this.form.date = null;
      this.form.failed = null;
      this.form.label = null;
      this.submitAlert = false;
      this.geoAlert = false;
      this.$refs.uploadForm.reset();
      this.submittingPhotoProgress = false;
      this.tookTooLongAlert = false;
      this.failedAudit = false;
    },
    getLocation() {
      // Get timestamp
      let date = new Date();
      this.form.date = date;

      function success(position) {
        const lat = position.coords.latitude;
        const long = position.coords.longitude;

        this.form.geolocation = {
          lat,
          long,
        };

        try {
          this.form.geolocation = JSON.stringify(this.form.geolocation);
        } catch (error) {}

        this.loadingGeolocation = false;
      }

      function error(err) {
        console.log(err);
        this.geoAlert = true;
      }

      var geo_options = {
        enableHighAccuracy: true,
        maximumAge: 30000,
        timeout: 27000,
      };

      if (!navigator.geolocation) {
        this.geoAlert = true;
      } else {
        this.geoAlert = false;
        navigator.geolocation.getCurrentPosition(
          success.bind(this),
          error.bind(this),
          geo_options
        );
      }
    },
    getSamplesByAuditorEvent() {
      let config = {
        url: `${this.getBaseUrl}/auditEvent/getAuditSamplesByAuditorId/${this.getAuditEvent.auditorID}`,
        method: "GET",
      };
      axios(config)
        .then((response) => {
          if (response.status === 200) {
            _.forEach(
              response.data,
              function (sample) {
                // Format name for mesmerize
                let name = `${sample.nth} - `;
                if (sample.opportunityID) {
                  name = name + `${sample.opportunityID} - `;
                }
                if (sample.pocCompanyID) {
                  name = name + `${sample.pocCompanyID} - `;
                }
                name = name + `${sample.doctorName} at ${sample.doctorAddress}`;

                this.companies.push({
                  name: name,
                  id: sample.id,
                  notes: sample.notes,
                });
              }.bind(this)
            );
          } else {
            // todo handle error
            console.log("Error getting samples");
          }
        })
        .catch((err) => {
          // eslint-disable-next-line
          console.log(err);
        });
    },
    validateUser() {
      if (this.getAuditEvent === null) {
        this.$router.push("/login");
      }

      // More validation is done server-side on submit
    },
    setNotes() {
      this.form.notes = null;
      for (let i = 0; i < this.companies.length; i++) {
        if (this.companies[i].id === this.form.company) {
          this.form.notes = this.companies[i].notes;
        }
      }
    },
  },
};
</script>

<style scoped>
.center-checkbox {
  align-items: center;
  justify-content: center;
}
</style>


